export default __webpack_public_path__ + "static/media/Proxy-Delhaize-Grande-Haie-4.ece41840.jpg";